import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Order } from '../../models/order.model';

import { NavigateService } from './../../services/navigate.service';
import { OrderService } from '../../services/order.service';

@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.scss']
})
export class OrderComponent implements OnInit {

  id: string;
  order: Order;
  panelOpenState: boolean;
  constructor(private activatedRoute: ActivatedRoute,
    private orderService: OrderService,
    public navigate: NavigateService
  ) { }

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.orderService.getSearch(this.id)
      .subscribe(r => this.order = r);
  }
}
